import type { FC } from 'react';

import ModalBody from './components/ModalBody';
import ModalHeader from './components/ModalHeader';
import ModalShell from './components/ModalShell';
import type { ModalProps } from './types';

const Modal: FC<ModalProps> = ({ children, title, ...restProps }) => (
    <ModalShell title={title} {...restProps}>
        <ModalHeader>{title}</ModalHeader>
        <ModalBody>{children}</ModalBody>
    </ModalShell>
);

export default Modal;
